TimedActionComponent.$inject = ['$scope', '$interval'];

function TimedActionComponent($scope, $interval) {
    const self = this;
    
    // Initialize component
    self.$onInit = function() {
        self.timer = 0; // Start with action available
        self.originalTimeout = self.timeout || 60;
        self.timeoutInterval = null;
    };
    
    // Handle input changes
    self.$onChanges = function(changes) {
        if (changes.timeout && !changes.timeout.isFirstChange()) {
            self.timer = changes.timeout.currentValue;
            self.originalTimeout = changes.timeout.currentValue;
        }
    };
    
    // Cleanup on destroy
    self.$onDestroy = function() {
        if (self.timeoutInterval) {
            $interval.cancel(self.timeoutInterval);
        }
    };
    
    // Start the countdown timer
    self.startTimer = function() {
        return new Promise((resolve) => {
            self.timer = self.originalTimeout;
            
            // Clear any existing interval
            if (self.timeoutInterval) {
                $interval.cancel(self.timeoutInterval);
            }
            
            // Start new countdown
            self.timeoutInterval = $interval(() => {
                self.timer--;
                if (self.timer <= 0) {
                    $interval.cancel(self.timeoutInterval);
                    self.timeoutInterval = null;
                    resolve(true);
                }
            }, 1000);
            
            resolve(true);
        });
    };
    
    // Handle action button click
    self.performAction = function() {
        if (self.timer <= 0 && !self.isPerforming) {
            // Start the timer to block future actions
            self.startTimer();
            
            // Call the action callback
            if (self.onAction) {
                self.onAction();
            }
        }
    };
    
    // Check if action can be performed
    self.canPerformAction = function() {
        return self.timer <= 0 && !self.isPerforming;
    };
}

export const TimedActionComponentOptions = {
    controller: TimedActionComponent,
    templateUrl: '../hmodules/components/h-timed-action/timed-action.component.html',
    bindings: {
        actionText: '@',        // Text to display for the action (e.g., "Resend")
        prefixText: '@',        // Text to display before the action (e.g., "Didn't get it?")
        performingText: '@',    // Text to display while action is being performed (e.g., "Resending")
        timeout: '<',           // Timeout in seconds
        isPerforming: '<',      // Boolean indicating if action is currently being performed
        sizing: '@',            // Button size: 'xs', 'sm', 'md', 'lg', 'xl'
        variant: '@',           // Button variant: 'primary', 'secondary', 'ghost', etc.
        onAction: '&'           // Callback function when action is triggered
    }
};
